/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LeadStageCount
 */
export interface LeadStageCount {
    /**
     * Review Stage (lead status) id for this cell; null when the lead has no review stage.
     * @type {string}
     * @memberof LeadStageCount
     */
    status_id?: string;
    /**
     * Admission status value for this cell; null when the lead has no admission status.
     * @type {string}
     * @memberof LeadStageCount
     */
    admission_status?: string;
    /**
     * Number of individual leads (not duplicate groups) in this cell.
     * @type {number}
     * @memberof LeadStageCount
     */
    count: number;
}

/**
 * Check if a given object implements the LeadStageCount interface.
 */
export function instanceOfLeadStageCount(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "count" in value;

    return isInstance;
}

export function LeadStageCountFromJSON(json: any): LeadStageCount {
    return LeadStageCountFromJSONTyped(json, false);
}

export function LeadStageCountFromJSONTyped(json: any, ignoreDiscriminator: boolean): LeadStageCount {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status_id': !exists(json, 'status_id') ? undefined : json['status_id'],
        'admission_status': !exists(json, 'admission_status') ? undefined : json['admission_status'],
        'count': json['count'],
    };
}

export function LeadStageCountToJSON(value?: LeadStageCount | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status_id': value.status_id,
        'admission_status': value.admission_status,
        'count': value.count,
    };
}

